import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';

export interface DateSelectorInputData {
  title: string;
  label: string;
  buttonText: string;
  date: Date | null;
}
@Component({
  selector: 'thred-date-selector-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
  ],
  templateUrl: './date-selector-dialog.component.html',
  styleUrls: ['./date-selector-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateSelectorDialogComponent {
  fg = this.fb.group({
    date: this.fb.control<Date | null>(this.data.date, {
      validators: [Validators.required],
    }),
  });

  constructor(
    private fb: NonNullableFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DateSelectorInputData,
    private dialogRef: MatDialogRef<DateSelectorDialogComponent, Date>,
  ) {}

  onSubmit() {
    if (this.fg.invalid) {
      return;
    } else {
      this.dialogRef.close(this.fg.getRawValue().date!);
    }
  }
}
